export default __webpack_public_path__ + "static/section_8_details_1-1b0a5ef60b94e52dcb4918d0da3b7838.png";